import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import typography from 'theme/typography';

const CustomButtonSearch = withStyles(theme => ({
  root: {
    '&.MuiButton-outlined': {
      ...typography.subtitle2,
      color: theme.palette.info.dark,
      borderColor: theme.palette.info.main,
      background: theme.palette.background.paper,
      padding: '7px 16px',
      filter: 'none',
      '&:hover': {
        border: `1px solid ${theme.palette.info.dark}`,
        background: theme.palette.background.paper,
        color: theme.palette.info.dark,
        fontWeight: 500,
        filter: 'none',
      },
      '&:active': {
        border: `1px solid ${theme.palette.info.light}`,
        background: theme.palette.backgrounds.backgroundFilters,
        color: theme.palette.primary.dark,
        filter: 'none',
      },
    },
  },
}))(Button);

export default CustomButtonSearch;
